var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"text-center"},[_c('v-select',{staticClass:"select",staticStyle:{"max-width":"60px","font-size":"11px"},attrs:{"items":_vm.variants,"item-value":"name","item-text":"name","label":"","dense":"","hide-details":"","menu-props":{
      bottom: true,
      offsetY: true,
      fontSize: 11,
      minWidth: 75,
      transition: 'scale-transition',
    },"single-line":""},on:{"change":_vm.changed},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }